import { TagIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedCoverageCategoryChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityStatusTransition,
  ActivityTitle,
  CoverageFields,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface CoverageCategoryChangedEventProps {
  event: DiscriminatedCoverageCategoryChangedEvent;
}

export const CoverageCategoryChangedEvent: React.FC<
  CoverageCategoryChangedEventProps
> = ({ event }) => {
  const { coverage, old_category, new_category } = event.payload;
  const user = getUserFromEvent(event);

  const carrierName = coverage?.carrier?.name;

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-purple-100">
          <TagIcon className="h-4 w-4 text-purple-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          {carrierName && <ActivityTitle>{carrierName}</ActivityTitle>}
          {old_category && new_category && (
            <ActivityStatusTransition
              from={formatStatus(old_category)}
              to={formatStatus(new_category)}
            />
          )}
        </div>
        <CoverageFields coverage={coverage} />
      </div>
    </ActivityBody>
  );

  const actions = event.payload.target_id && (
    <ActivityActions>
      <ActivityLink
        href={`/matters/${event.matter_id}/coverage/${event.payload.target_id}`}
      >
        View Coverage
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Coverage Category Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
